import NotificationsDrawer from './notifications';
import './styles.scss';

export default NotificationsDrawer;
